import { create } from "zustand";

const spaceStore = create((set, get) => ({
  // UI State only - data moved to React Query
  loading: true,
  openSpectraId: null,
  
  setOpenSpectraId: (value) =>
    set({
      openSpectraId: value,
    }),
}));

export default spaceStore;
